var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getClassName("purchase"), attrs: { id: "purchase" } },
    [
      _c("div", { class: _vm.getClassName("purchase__caption") }, [
        _vm._v("購入内容")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.getClassName("purchase__cell") },
        [
          _c(
            "div",
            {
              class: _vm
                .getClassName("purchase__summary")
                .concat(["purchase__summary--counter"])
            },
            [
              _c("span", { staticClass: "purchase__counter" }, [_vm._v("❶")]),
              _vm._v("\n      種類を選択してください。\n    ")
            ]
          ),
          _vm._v(" "),
          _c("SelectColors", {
            class: _vm.getClassName("purchase__colors"),
            attrs: { items: [_vm.item], media: _vm.media },
            model: {
              value: _vm.form,
              callback: function($$v) {
                _vm.form = $$v
              },
              expression: "form"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.getClassName("purchase__cell") },
        [
          _c(
            "div",
            {
              class: _vm
                .getClassName("purchase__summary")
                .concat(["purchase__summary--counter"])
            },
            [
              _c("span", { staticClass: "purchase__counter" }, [_vm._v("❷")]),
              _vm._v(" "),
              _vm.isCurtainMadomo
                ? [_vm._v(" 本体生地サイズを選択してください。 ")]
                : [_vm._v("サイズを選択してください。")],
              _vm._v(" "),
              _vm.item.category.size_image
                ? _c(
                    "a",
                    {
                      class: _vm.getClassName("purchase__show-model"),
                      on: {
                        click: function($event) {
                          return _vm.showModal(_vm.item.category.size_image)
                        }
                      }
                    },
                    [_vm._v("サイズの選び方")]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("SelectSizes", {
            class: _vm.getClassName("purchase__sizes"),
            attrs: { item: _vm.item, media: _vm.media },
            model: {
              value: _vm.form,
              callback: function($$v) {
                _vm.form = $$v
              },
              expression: "form"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isIronCurtainRail
        ? _c(
            "div",
            { class: _vm.getClassName("purchase__cell") },
            [
              _c("ApprovalIronCurtainRail", {
                class: _vm.getClassName("purchase__ironcurtainrail"),
                attrs: { item: _vm.item, media: _vm.media },
                on: { approvalIronCurtainRail: _vm.approvalIronCurtainRail },
                model: {
                  value: _vm.form,
                  callback: function($$v) {
                    _vm.form = $$v
                  },
                  expression: "form"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.getClassName("purchase__cell") },
        [
          _c(
            "div",
            {
              class: _vm
                .getClassName("purchase__summary")
                .concat(["purchase__summary--counter"])
            },
            [
              _c("span", { staticClass: "purchase__counter" }, [_vm._v("❸")]),
              _vm._v(
                "\n      購入" +
                  _vm._s(_vm.item.unit) +
                  "数を選択してください。\n      "
              ),
              _vm.isCurtainMadomo
                ? [_c("br"), _vm._v("両開きの場合は2枚ご購入ください。")]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("InputQuantity", {
            class: _vm.getClassName("purchase__quantity"),
            attrs: { item: _vm.item, media: _vm.media },
            model: {
              value: _vm.form,
              callback: function($$v) {
                _vm.form = $$v
              },
              expression: "form"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.item.parts_categories.length > 0
        ? _c(
            "div",
            { class: _vm.getClassName("purchase__cell") },
            [
              _c(
                "div",
                {
                  class: _vm
                    .getClassName("purchase__summary")
                    .concat(["purchase__summary--counter"])
                },
                [
                  _c("span", { staticClass: "purchase__counter" }, [
                    _vm._v("❹")
                  ]),
                  _vm._v(" "),
                  _vm.isCustomId1
                    ? [_vm._m(0)]
                    : _vm.isCustomId2
                    ? [_vm._m(1)]
                    : _vm.isCustomId4
                    ? [_vm._m(2)]
                    : _vm.isCurtainMadomo
                    ? [
                        _c("p", [
                          _vm._v(
                            "生地とレールをつなぐパーツをお選びください。"
                          ),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.isCustomId3
                            ? _c("span", [
                                _vm._v(
                                  "リボンまたはボタンストラップをカーテンランナーにつなげて掛けたい方は、ランナー専用パーツも合わせてお選びください。"
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v("\n        ※パーツは８本セットが基本です"),
                          _c("br"),
                          _vm._v(
                            "\n        ※パーツが不要な場合は「パーツなし」をお選びください"
                          ),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.isCustomId3
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "purchase__counter__simlator-link",
                                  attrs: { href: "#simulator" }
                                },
                                [_vm._v("※シミュレーションをしてみる")]
                              )
                            : _vm._e()
                        ])
                      ]
                    : _vm.isMekakushiMadomo
                    ? [
                        _c("p", [
                          _vm._v(
                            "生地と突っ張り棒をつなぐパーツをお選びください。"
                          ),
                          _c("br"),
                          _vm._v("\n        ※パーツは８本セットが基本です"),
                          _c("br"),
                          _vm._v(
                            "\n        ※パーツが不要な場合は「パーツなし」をお選びください"
                          ),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.isCustomId5
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "purchase__counter__simlator-link",
                                  attrs: { href: "#simulator" }
                                },
                                [_vm._v("※シミュレーションをしてみる")]
                              )
                            : _vm._e()
                        ])
                      ]
                    : _vm.isLongApron
                    ? [
                        _vm._v("\n        肩ひものリボンを2本お選びください。"),
                        _c("br"),
                        _vm._v(
                          "\n        前結びスタイルや男性がご使用の場合はロングリボンをお選びください。"
                        ),
                        _c("br")
                      ]
                    : _vm.isCustomizedBag
                    ? [_vm._v("持ち手（ストラップ）をお選びください。")]
                    : _vm.isCushionCover
                    ? [
                        _vm._v(
                          "\n        着せ替えクロス（10WAYクロス）が必要な方はお選びください。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n        クッションカバーの４角にあるボタンに取り付けてお使いいただけます。\n      "
                        )
                      ]
                    : [_vm._v("パーツが必要な方はお選びください。")],
                  _vm._v(" "),
                  _vm.item.category.parts_image &&
                  !_vm.isCustomId1 &&
                  !_vm.isCustomId2 &&
                  !_vm.isCustomId3
                    ? _c(
                        "a",
                        {
                          class: _vm.getClassName("purchase__show-model"),
                          on: {
                            click: function($event) {
                              return _vm.showModal(
                                _vm.item.category.parts_image
                              )
                            }
                          }
                        },
                        [_vm._v("パーツの選び方")]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("SelectParts", {
                class: _vm.getClassName("purchase__parts"),
                attrs: {
                  item: _vm.item,
                  media: _vm.media,
                  noPartsVueFlg:
                    _vm.isCurtainMadomo || _vm.isMekakushiMadomo ? true : false
                },
                on: { noSelection: _vm.noSelection },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "items",
                      fn: function() {
                        return [
                          _vm.getParts.length > 0
                            ? _c(
                                "div",
                                { class: _vm.getClassName("parts-items") },
                                _vm._l(_vm.getParts, function(part, index) {
                                  return _c("PartsItem", {
                                    key: part.id + "-" + part.option.id,
                                    attrs: { item: part, media: _vm.media },
                                    on: { "remove-parts": _vm.removeParts },
                                    model: {
                                      value: _vm.form.parts[index],
                                      callback: function($$v) {
                                        _vm.$set(_vm.form.parts, index, $$v)
                                      },
                                      expression: "form.parts[index]"
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3314178906
                ),
                model: {
                  value: _vm.form,
                  callback: function($$v) {
                    _vm.form = $$v
                  },
                  expression: "form"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.getClassName("purchase__cell") },
        [
          _c("AddCart", {
            class: _vm.getClassName("purchase__price"),
            attrs: {
              item: _vm.item,
              form: _vm.form,
              "enable-cart": _vm.enableCart,
              media: _vm.media,
              noPartsVueFlg:
                _vm.isCurtainMadomo || _vm.isMekakushiMadomo ? true : false,
              noPartsFlg: _vm.noPartsFlg,
              isIronCurtainRail: _vm.isIronCurtainRail,
              noApprovalIronCurtainRailFlg: _vm.noApprovalIronCurtainRailFlg
            },
            on: { alert: _vm.applyAlert }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("PurchaseModal", {
        attrs: {
          visible: _vm.modal.visible,
          content: _vm.modal.content,
          media: _vm.media
        },
        on: { hide: _vm.hideModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("オプションパーツが必要な方はお選びください。"),
      _c("br"),
      _vm._v(
        "\n        ※「kami」は同じ生地で製作する「共紐」8本がセットでの価格です。"
      ),
      _c("br"),
      _vm._v(
        "\n        ※別途オプションパーツをご購入いただいても「共紐」は付属されます。"
      ),
      _c("br"),
      _vm._v(
        "\n        ※オプションパーツが不要な場合は「パーツなし」をお選びください。"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("生地とレールをつなぐパーツをお選びください。"),
      _c("br"),
      _vm._v("\n        ※パーツは８本セットが基本です"),
      _c("br"),
      _vm._v("\n        ※パーツが不要な場合は「パーツなし」をお選びください")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("オプションパーツが必要な方はお選びください。"),
      _c("br"),
      _vm._v(
        "\n        ※「ooasa」は同じ生地で製作する「共紐」8本がセットでの価格です"
      ),
      _c("br"),
      _vm._v(
        "\n        ※別途オプションパーツをご購入いただいても「共紐」は付属されます"
      ),
      _c("br"),
      _vm._v(
        "\n        ※オプションパーツが不要な場合は「パーツなし」をお選びください"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }